export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10183.ef3a12a1.jpg";